import HeaderSection from '../../../../components/Header/HeaderSection';
import CardTransparent from '../../../../components/CockpitCards/CardTransparent';


export default function MicrobiomeText() {

    
    return (

     <CardTransparent content = {
        <HeaderSection

            headline_p1 = "Check" 
            headline_grey = "cardiovascular"
            headline_p2 = "microbiome dysbiosis"

            text1 = "Microbiome dysbiosis affects cardiovascular health and may increase the risk for CVDs."
            text2 = "Discuss with your doctor potential ways to restore a healthy gut microbiome."

        
            />
    }/>
            
  )
}